<template>
  <div class="header" id="header" :style="headerStyle">
    <!-- 顶部导航栏 -->
    <div class="top-nav">
      <div class="nav-left">
        <div class="logo">
          <span class="logo-text">九阵数字云诊所</span>
        </div>
<!--        <div class="nav-tabs">
          <div
            v-for="tab in navTabs"
            :key="tab.id"
            :class="['nav-tab', { active: activeTab === tab.id }]"
            @click="switchTab(tab.id)"
          >
            {{ tab.name }}
          </div>
        </div>-->
      </div>
      
      <!-- 中间部分：当前系统时间 -->
      <div class="nav-center">
        <div class="current-time">
          <div class="time-display">{{ currentTime }}</div>
          <div class="date-display">{{ currentDate }}</div>
        </div>
      </div>
      
      <div class="nav-right">
        <div class="user-info">
<!--          <el-avatar :size="32" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" />-->
          
          <!-- 下拉菜单 -->
          <el-dropdown 
            trigger="hover" 
            placement="bottom-end"
            @command="handleDropdownCommand"
          >
            <div class="user-detail dropdown-trigger">
              <div class="company-name">{{ userInfo.company }}</div>
              <i class="el-icon-arrow-down dropdown-arrow"></i>
            </div>
            
            <el-dropdown-menu slot="dropdown" class="user-dropdown-menu">
              <el-dropdown-item command="clearCache" class="dropdown-item">
                <i class="el-icon-delete"></i>
                <span>清理缓存</span>
              </el-dropdown-item>
              <el-dropdown-item command="logout" class="dropdown-item">
                <i class="el-icon-switch-button"></i>
                <span>退出系统</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      // 顶部导航标签
      navTabs: [
        { id: 'todo', name: '我的待办' },
        { id: 'process', name: '流程中心' },
        { id: 'report', name: '我的报告' },
        { id: 'monitor', name: '系统监控' }
      ],
      activeTab: 'todo',
      
      // 用户信息
      userInfo: {
        company: localStorage.getItem('username') || '后台系统',
      },
      
      // 当前背景设置
      currentBackground: null,
      
      // 当前时间
      currentTime: '',
      currentDate: '',
      timeInterval: null
    };
  },
  computed: {
    headerStyle() {
      if (!this.currentBackground) return {
        backgroundColor: '#2c4f79',
        color: '#ffffff'
      };

      const style = {};
      if (this.currentBackground.type === 'solid') {
        style.backgroundColor = this.currentBackground.color;
        style.color = this.currentBackground.textColor;
      } else {
        style.backgroundImage = `url(${this.currentBackground.url})`;
        style.backgroundSize = 'cover';
        style.backgroundPosition = 'center';
        style.backgroundRepeat = 'no-repeat';
        style.backgroundAttachment = 'fixed';
      }
      return style;
    }
  },
  methods: {
    // 切换顶部导航
    switchTab(tabId) {
      this.activeTab = tabId;
      this.$message.info(`切换到${this.navTabs.find(t => t.id === tabId).name}`);
    },
    
    // 初始化背景
    initBackground() {
      const savedBg = localStorage.getItem('appBackground');
      if (savedBg) {
        this.currentBackground = JSON.parse(savedBg);
      } else {
        this.currentBackground = {
          title: '默认深蓝',
          color: '#2c4f79',
          textColor: '#ffffff',
          type: 'solid'
        };
        localStorage.setItem('appBackground', JSON.stringify(this.currentBackground));
      }
    },
    
    // 更新时间
    updateTime() {
      const now = new Date();
      
      // 格式化时间 HH:MM:SS
      const hours = now.getHours().toString().padStart(2, '0');
      const minutes = now.getMinutes().toString().padStart(2, '0');
      const seconds = now.getSeconds().toString().padStart(2, '0');
      this.currentTime = `${hours}:${minutes}:${seconds}`;
      
      // 格式化日期 YYYY年MM月DD日 星期X
      const year = now.getFullYear();
      const month = (now.getMonth() + 1).toString().padStart(2, '0');
      const day = now.getDate().toString().padStart(2, '0');
      const weekDays = ['日', '一', '二', '三', '四', '五', '六'];
      const weekDay = weekDays[now.getDay()];
      this.currentDate = `${year}年${month}月${day}日 星期${weekDay}`;
    },
    
    // 下拉菜单命令处理
    handleDropdownCommand(command) {
      switch (command) {
        case 'clearCache':
          this.clearCache();
          break;
        case 'logout':
          this.logout();
          break;
      }
    },
    
    // 清理缓存
    clearCache() {
      this.$confirm('确定要清理所有缓存吗？这将清除本地存储和会话存储数据。', '清理缓存', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'clear-cache-confirm'
      }).then(() => {
        try {
          // 清除本地存储
          localStorage.clear();
          // 清除会话存储
          sessionStorage.clear();
          
          this.$message.success('缓存清理成功！');
          
          // 延迟跳转到登录页
          setTimeout(() => {
            this.$router.push('/login');
          }, 1000);
          
        } catch (error) {
          console.error('清理缓存失败:', error);
          this.$message.error('缓存清理失败');
        }
      }).catch(() => {
        // 用户取消操作
        this.$message.info('已取消清理缓存');
      });
    },
    
    // 退出系统
    logout() {
      this.$confirm('确定要退出系统吗？', '退出系统', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'logout-confirm'
      }).then(() => {
        try {
          // 清除所有存储
          localStorage.clear();
          sessionStorage.clear();
          
          this.$message.success('已退出系统');
          
          // 跳转到登录页
          this.$router.push('/login');
          
        } catch (error) {
          console.error('退出系统失败:', error);
          this.$message.error('退出系统失败');
        }
      }).catch(() => {
        // 用户取消操作
        this.$message.info('已取消退出');
      });
    }
  },
  mounted() {
    this.initBackground();
    
    // 初始化时间
    this.updateTime();
    
    // 每秒更新一次时间
    this.timeInterval = setInterval(() => {
      this.updateTime();
    }, 1000);
  },
  beforeDestroy() {
    // 清除定时器
    if (this.timeInterval) {
      clearInterval(this.timeInterval);
    }
  }
};
</script>

<style lang="less" scoped>
.header {
  background-color: #2c4f79;
  color: #ffffff;
  width: 100%;
  display: flex;
  flex-direction: column;
  position: static;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  height: auto;
  min-height: 60px;
  transition: all 0.3s ease;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(44, 79, 121, 0.9);
    z-index: -1;
  }
	::v-deep .el-dropdown{
		  color: #f5f7fa;
	}
  /* 顶部导航栏样式 */
  .top-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 24px;
    height: 60px;
    background: transparent;
    color: white;
    z-index: 1000;
    
    .nav-left {
      display: flex;
      align-items: center;
      flex: 1;
      
      .logo {
        margin-right: 40px;
        
        .logo-text {
          font-size: 20px;
          font-weight: bold;
          color: white;
        }
      }
      
      .nav-tabs {
        display: flex;
        gap: 8px;
        
        .nav-tab {
          padding: 8px 16px;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.3s;
          font-size: 14px;
          
          &:hover {
            background: rgba(255, 255, 255, 0.1);
          }
          
          &.active {
            background: rgba(255, 255, 255, 0.2);
            font-weight: bold;
          }
        }
      }
    }
    
    /* 中间时间显示 */
    .nav-center {
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1;
      
      .current-time {
        text-align: center;
        padding: 8px 16px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.1);
        transition: all 0.3s;
        
        &:hover {
          background: rgba(255, 255, 255, 0.15);
        }
        
        .time-display {
          font-size: 18px;
          font-weight: bold;
          font-family: 'Arial', sans-serif;
          letter-spacing: 1px;
        }
        
        .date-display {
          font-size: 12px;
          opacity: 0.9;
          margin-top: 2px;
        }
      }
    }
    
    .nav-right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      flex: 1;
      
      .user-info {
        display: flex;
        align-items: center;
        gap: 12px;
        position: relative;
        
        .dropdown-trigger {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 8px 12px;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.3s;
          position: relative;
          
          &:hover {
            background: rgba(255, 255, 255, 0.1);
            
            .dropdown-arrow {
              transform: rotate(180deg);
            }
          }
          
          .user-detail {
            display: flex;
            flex-direction: column;
            
            .company-name {
              font-size: 14px;
              font-weight: bold;
            }
            
            .position-name {
              font-size: 12px;
              opacity: 0.8;
            }
          }
          
          .dropdown-arrow {
            font-size: 12px;
            transition: transform 0.3s;
            margin-left: 4px;
          }
        }
      }
    }
  }
}

/* 下拉菜单样式 */
.user-dropdown-menu {
  margin-top: 5px;
  border: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  overflow: hidden;
  
  .dropdown-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 16px;
    font-size: 14px;
    transition: all 0.3s;
    
    i {
      font-size: 16px;
    }
    
    &:hover {
      background: #f5f7fa;
      color: #409EFF;
    }
    
    &:first-child:hover {
      i {
        color: #F56C6C;
      }
    }
    
    &:last-child:hover {
      i {
        color: #E6A23C;
      }
    }
  }
   
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background: #f5f7fa;
    color: #409EFF;
  }
}

/* 响应式设计 */
@media (max-width: 992px) {
  .top-nav {
    padding: 0 12px;
    
    .nav-left {
      .nav-tabs {
        .nav-tab {
          padding: 8px 12px;
          font-size: 13px;
        }
      }
      
      .logo {
        margin-right: 20px;
        
        .logo-text {
          font-size: 18px;
        }
      }
    }
    
    .nav-center {
      .current-time {
        padding: 6px 12px;
        
        .time-display {
          font-size: 16px;
        }
        
        .date-display {
          font-size: 11px;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .top-nav {
    padding: 0 12px;
    
    .nav-left {
      .logo {
        margin-right: 15px;
        
        .logo-text {
          font-size: 16px;
        }
      }
      
      .nav-tabs {
        .nav-tab {
          padding: 6px 10px;
          font-size: 12px;
        }
      }
    }
    
    .nav-center {
      .current-time {
        padding: 4px 8px;
        
        .time-display {
          font-size: 14px;
        }
        
        .date-display {
          font-size: 10px;
        }
      }
    }
    
    .nav-right {
      .user-info {
        .dropdown-trigger {
          padding: 6px 10px;
          
          .user-detail {
            .company-name {
              font-size: 12px;
            }
            
            .position-name {
              font-size: 10px;
            }
          }
        }
      }
    }
  }
}

@media (max-width: 480px) {
  .top-nav {
    flex-direction: column;
    height: auto;
    padding: 10px;
    
    .nav-left {
      width: 100%;
      justify-content: center;
      margin-bottom: 10px;
      
      .logo {
        margin-right: 15px;
        
        .logo-text {
          font-size: 16px;
        }
      }
      
      .nav-tabs {
        flex-wrap: wrap;
        justify-content: center;
      }
    }
    
    .nav-center {
      width: 100%;
      margin-bottom: 10px;
    }
    
    .nav-right {
      width: 100%;
      justify-content: center;
    }
  }
}
</style>